export const ACCEPTED_FILE_TYPES = '.jpg,.jpeg,.png';
